import React, { useState } from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Button,
  Box,
  Breadcrumbs,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import {
  Folder,
  FolderOpen,
  InsertDriveFile,
  ExpandLess,
  ExpandMore,
  CameraAlt,
  UploadFile,
  PhotoLibrary,
  MoreVert,
} from "@mui/icons-material";
import FileViewer from "react-file-viewer"; // For previewing DOCX and other file types

function FileTreeView() {
  const files = [
    {
      name: "Annual leave policy.docx",
      version: "Version: 1.0",
      path: "../../assets/files/annual_leave_policy.docx", // If you want a static path
    },
    {
      name: "Staff Absence Policy.docx",
      version: "Version: 1.1",
      path: "../../assets/files/staff_absence_policy.docx", // Static path in the public folder
    },
  ];
  const [openRoot, setOpenRoot] = useState(null); // Track the open root folder
  const [openSubfolder, setOpenSubfolder] = useState(null); // Track the open subfolder for each root
  const [breadcrumbTrail, setBreadcrumbTrail] = useState([]); // Track the breadcrumb trail
  const [anchorEl, setAnchorEl] = useState(null); // For 3-dots menu
  const [selectedItem, setSelectedItem] = useState(null); // Track selected item
  const [openDialog, setOpenDialog] = useState(false); // For file version dialog
  const [openVersionDialog, setOpenVersionDialog] = useState(false); // For file versions dialog

  const [previewFile, setPreviewFile] = useState(null); // To store the selected file for preview

  const handleToggleRoot = (folder) => {
    setOpenRoot((prev) => (prev === folder ? null : folder));
    setOpenSubfolder(null); // Reset subfolder when toggling root
    setBreadcrumbTrail([folder]); // Set breadcrumb to the root folder
  };

  const handleCloseDialog = () => {
    setOpenDialog(false); // Close preview dialog
    setPreviewFile(null); // Reset preview file
  };
  const handleCloseVersionDialog = () => {
    setOpenVersionDialog(false); // Close version dialog
  };

  const handleToggleSubfolder = (subfolder) => {
    setOpenSubfolder((prev) => (prev === subfolder ? null : subfolder));
    setBreadcrumbTrail((prev) => {
      const newTrail = [breadcrumbTrail[0]];
      if (openRoot && openSubfolder !== subfolder) {
        newTrail.push(subfolder);
      }
      return newTrail;
    });
  };

  const handleMenuClick = (event, item) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(item);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleRename = () => {
    alert(`Renaming ${selectedItem}`);
    handleMenuClose();
  };

  const handleDelete = () => {
    alert(`Deleting ${selectedItem}`);
    handleMenuClose();
  };

  const handleShare = () => {
    alert(`Sharing ${selectedItem}`);
    handleMenuClose();
  };

  // const handleVersionClick = () => {
  //   setOpenDialog(true); // Open dialog for file versions
  // };
  const handleView = () => {
    // Find the selected file
    const selectedFile = files.find((file) => file.name === selectedItem);
    if (selectedFile) {
      setPreviewFile(selectedFile); // Set the file to preview
      setOpenDialog(true); // Open the preview dialog
    }
    handleMenuClose(); // Close the menu
  };

  const handleViewVersions = () => {
    setOpenVersionDialog(true); // Open the versions dialog
    handleMenuClose(); // Close the menu
  };

  const handleScanFile = () => alert("Opening camera for file scan...");
  const handleUploadFile = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      if (file) alert(`File uploaded: ${file.name}`);
    };
    fileInput.click();
  };
  const handleChooseFromLibrary = () =>
    alert("Opening library for file selection...");

  return (
    <div>
      {/* Button Row */}
      <Box display="flex" flexDirection="column" gap={1} mb={2}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<CameraAlt />}
          onClick={handleScanFile}
        >
          Scan File
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<UploadFile />}
          onClick={handleUploadFile}
        >
          Upload File
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<PhotoLibrary />}
          onClick={handleChooseFromLibrary}
        >
          Choose from Library
        </Button>
      </Box>

      {/* Breadcrumbs */}
      <Breadcrumbs
        aria-label="breadcrumb"
        mb={2}
        sx={{
          display: "flex",
          flexWrap: "nowrap",
          alignItems: "center",
          fontSize: "1rem", // Clean font size
          color: "text.secondary", // Subtle text color for breadcrumbs
        }}
      >
        {breadcrumbTrail.length === 0 ? (
          <span color="textPrimary" sx={{ fontWeight: "bold" }}>
            /
          </span>
        ) : (
          <>
            <span color="textPrimary" sx={{ fontWeight: "bold", mr: 0.5 }}>
              /&nbsp;
            </span>
            {breadcrumbTrail.map((crumb, index) => (
              <Typography
                key={index}
                color="textPrimary"
                sx={{
                  display: "inline",
                  fontWeight:
                    index === breadcrumbTrail.length - 1 ? "bold" : "normal",
                  fontSize: "small",
                  "&:hover": {
                    textDecoration: "underline", // Hover effect
                    cursor: "pointer",
                  },
                  mr: 0.5,
                }}
              >
                {index > 0 && (
                  <span component="span" sx={{ mx: 0.5 }} color="textSecondary">
                    /&nbsp;
                  </span>
                )}
                {crumb}
              </Typography>
            ))}
          </>
        )}
      </Breadcrumbs>

      {/* File Tree Structure */}
      <List>
        {/* Root Folders */}
        <ListItem button onClick={() => handleToggleRoot("Health and Safety")}>
          <ListItemIcon>
            {openRoot === "Health and Safety" ? <FolderOpen /> : <Folder />}
          </ListItemIcon>
          <ListItemText primary="Health and Safety" />
          {openRoot === "Health and Safety" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={openRoot === "Health and Safety"}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            <ListItem
              button
              sx={{ pl: 4 }}
              onClick={() => handleToggleSubfolder("Master Bathroom")}
            >
              <ListItemIcon>
                {openSubfolder === "ToolBox Talks" ? (
                  <FolderOpen />
                ) : (
                  <Folder />
                )}
              </ListItemIcon>
              <ListItemText primary="ToolBox Talks" />
              {openSubfolder === "ToolBox Talks" ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItem>
            <Collapse
              in={openSubfolder === "ToolBox Talks"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  sx={{ pl: 8 }}
                  button
                  onClick={(e) => handleMenuClick(e, "First Aid Brief")}
                >
                  <ListItemIcon>
                    <InsertDriveFile />
                  </ListItemIcon>
                  <ListItemText
                    primary="First Aid Brief"
                    secondary="Version: 1.0"
                  />
                  <IconButton
                    onClick={(e) => handleMenuClick(e, "First Aid Brief")}
                  >
                    <MoreVert />
                  </IconButton>
                </ListItem>
                <ListItem
                  sx={{ pl: 8 }}
                  button
                  onClick={(e) => handleMenuClick(e, "Safe Handling")}
                >
                  <ListItemIcon>
                    <InsertDriveFile />
                  </ListItemIcon>
                  <ListItemText
                    primary="Safe Handling"
                    secondary="Version: 1.1"
                  />
                  <IconButton
                    onClick={(e) => handleMenuClick(e, "Safe Handling")}
                  >
                    <MoreVert />
                  </IconButton>
                </ListItem>
              </List>
            </Collapse>
            <ListItem
              button
              sx={{ pl: 4 }}
              onClick={() => handleToggleSubfolder("Folder B")}
            >
              <ListItemIcon>
                {openSubfolder === "Folder B" ? <FolderOpen /> : <Folder />}
              </ListItemIcon>
              <ListItemText primary="Folder B" />
              {openSubfolder === "Folder B" ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={openSubfolder === "Folder B"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                <ListItem
                  sx={{ pl: 8 }}
                  button
                  onClick={(e) => handleMenuClick(e, "File B1")}
                >
                  <ListItemIcon>
                    <InsertDriveFile />
                  </ListItemIcon>
                  <ListItemText primary="File B1" secondary="Version: 1.2" />
                  <IconButton onClick={(e) => handleMenuClick(e, "File B1")}>
                    <MoreVert />
                  </IconButton>
                </ListItem>
              </List>
            </Collapse>
          </List>
        </Collapse>
        {/* Additional root folders */}
        {/* Holidays folder with a new 'Policies' folder */}
        <ListItem button onClick={() => handleToggleRoot("Holidays")}>
          <ListItemIcon>
            {openRoot === "Holidays" ? <FolderOpen /> : <Folder />}
          </ListItemIcon>
          <ListItemText primary="Holidays" />
          {openRoot === "Holidays" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openRoot === "Holidays"} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem
              button
              sx={{ pl: 4 }}
              onClick={() => handleToggleSubfolder("Company Policies")}
            >
              <ListItemIcon>
                {openSubfolder === "Company Policies" ? (
                  <FolderOpen />
                ) : (
                  <Folder />
                )}
              </ListItemIcon>
              <ListItemText primary="Company Policies" />
              {openSubfolder === "Company Policies" ? (
                <ExpandLess />
              ) : (
                <ExpandMore />
              )}
            </ListItem>
            <Collapse
              in={openSubfolder === "Company Policies"}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {files.map((file, index) => (
                  <ListItem
                    key={index}
                    sx={{ pl: 8 }}
                    button
                    onClick={(e) => handleMenuClick(e, file.name)}
                  >
                    <ListItemIcon>
                      <InsertDriveFile />
                    </ListItemIcon>
                    <ListItemText
                      primary={file.name}
                      secondary={file.version}
                    />
                    <IconButton onClick={(e) => handleMenuClick(e, file.name)}>
                      <MoreVert />
                    </IconButton>
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </List>
        </Collapse>

        <ListItem button onClick={() => handleToggleRoot("10B Sesame Street")}>
          <ListItemIcon>
            {openRoot === "10B Sesame Street" ? <FolderOpen /> : <Folder />}
          </ListItemIcon>
          <ListItemText primary="10B Sesame Street" />
          {openRoot === "10B Sesame Street" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={openRoot === "10B Sesame Street"}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* Subfolders here if needed */}
          </List>
        </Collapse>

        {/* Remaining root folders */}
        <ListItem button onClick={() => handleToggleRoot("36 Mays Ave")}>
          <ListItemIcon>
            {openRoot === "36 Mays Ave" ? <FolderOpen /> : <Folder />}
          </ListItemIcon>
          <ListItemText primary="36 Mays Ave" />
          {openRoot === "36 Mays Ave" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={openRoot === "36 Mays Ave"} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {/* Subfolders here if needed */}
          </List>
        </Collapse>

        <ListItem button onClick={() => handleToggleRoot("21 Orchard St")}>
          <ListItemIcon>
            {openRoot === "21 Orchard St" ? <FolderOpen /> : <Folder />}
          </ListItemIcon>
          <ListItemText primary="21 Orchard St" />
          {openRoot === "21 Orchard St" ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse
          in={openRoot === "21 Orchard St"}
          timeout="auto"
          unmountOnExit
        >
          <List component="div" disablePadding>
            {/* Subfolders here if needed */}
          </List>
        </Collapse>
      </List>

      {/* Context Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleView}>View</MenuItem>
        <MenuItem onClick={handleRename}>Rename</MenuItem>
        <MenuItem onClick={handleDelete}>Delete</MenuItem>
        <MenuItem onClick={handleViewVersions}>File Versions</MenuItem>
        {selectedItem && selectedItem.startsWith("File") && (
          <MenuItem onClick={handleShare}>Share</MenuItem>
        )}
      </Menu>
      {/* File Preview Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>
          Preview: {previewFile ? previewFile.name : ""}
        </DialogTitle>
        <DialogContent>
          {previewFile ? (
            <FileViewer
              fileType={previewFile.type}
              filePath={previewFile.path}
            />
          ) : (
            <Typography>No preview available for this file type.</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Close</Button>
        </DialogActions>
      </Dialog>
      {/* File Versions Dialog */}
      <Dialog open={openVersionDialog} onClose={handleCloseVersionDialog}>
        <DialogTitle>File Versions</DialogTitle>
        <DialogContent>
          <Typography>No previous versions</Typography>
          {/* Here you can add dummy versions or handle versions dynamically */}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseVersionDialog}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default FileTreeView;
